import { IMarketingCenterTemplate } from '@/models/marketingCenter/template';
import {
  TitleCanvasElement,
  BackgroundImageCanvasElement,
  TextCanvasElement,
  BrandCanvasElement
} from '@/models/marketingCenter/elements';
import {
  InstagramPostFormat,
  InstagramStoryFormat,
  FacebookPostFormat
} from '@/models/marketingCenter/formats';
import { EMarketingCenterColorSchemes } from '../colorScheme';

const GiftTemplate: IMarketingCenterTemplate = {
  tag: 'Sell Coins',
  title: 'Gift Coin Post',
  description:
    'Let people know that you’re open to sell Coins and promote your business by the Gift Coins.',
  disabledDescription:
    'To create a Gift Coin Post, first you will need to activate the Sell Coins feature.',
  button: {
    label: 'Sell coins',
    link: '/sell-coins'
  },
  placeholders: {
    title: 'The new way to:',
    text: 'Send Gift Cards',
    colorScheme: EMarketingCenterColorSchemes.PINK,
    textMaxLength: 17,
    titleMaxLength: 20
  },
  formats: [
    new InstagramStoryFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/gift/instagram-story.png'
      }),
      new BrandCanvasElement({
        width: 32,
        height: 32,
        x: 187,
        y: 147,
        radius: 16,
        borderWidth: 2
      }),
      new TextCanvasElement({
        font: {
          size: 12,
          weight: 'bold',
          lineHeight: 12,
          numberOfLines: 1
        },
        position: {
          x: -72,
          y: 156
        },
        text: args => args.business.name
      }),
      new TitleCanvasElement({
        font: {
          size: 20,
          weight: 'bold',
          lineHeight: 20,
          maxWidth: 208,
          align: 'center',
          numberOfLines: 1
        },
        position: {
          x: 22,
          y: 201
        }
      }),
      new TextCanvasElement({
        font: {
          size: 46,
          weight: 'bold',
          lineHeight: 47,
          maxWidth: 173,
          align: 'center',
          numberOfLines: 3
        },
        position: {
          x: 39,
          y: 228
        }
      })
    ]),
    new InstagramPostFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/gift/instagram-post.png'
      }),
      new BrandCanvasElement({
        width: 32,
        height: 32,
        x: 187,
        y: 116,
        radius: 16,
        borderWidth: 2
      }),
      new TextCanvasElement({
        font: {
          size: 12,
          weight: 'bold',
          lineHeight: 12,
          numberOfLines: 1
        },
        position: {
          x: -72,
          y: 126
        },
        text: args => args.business.name
      }),
      new TitleCanvasElement({
        font: {
          size: 12,
          weight: 'bold',
          lineHeight: 20,
          maxWidth: 173,
          align: 'center',
          numberOfLines: 1
        },
        position: {
          x: 40,
          y: 164
        }
      }),
      new TextCanvasElement({
        font: {
          size: 18,
          weight: 'bold',
          lineHeight: 20,
          maxWidth: 173,
          align: 'center',
          numberOfLines: 1
        },
        position: {
          x: 40,
          y: 184
        }
      })
    ]),
    new FacebookPostFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/gift/facebook-post.png'
      }),
      new BrandCanvasElement({
        width: 24,
        height: 24,
        x: 120,
        y: 84,
        radius: 12,
        borderWidth: 2
      }),
      new TextCanvasElement({
        font: {
          size: 8,
          weight: 'bold',
          lineHeight: 8,
          numberOfLines: 1
        },
        position: {
          x: -135,
          y: 94
        },
        text: args => args.business.name
      }),
      new TitleCanvasElement({
        font: {
          size: 8,
          weight: 'bold',
          lineHeight: 17,
          maxWidth: 89,
          numberOfLines: 1
        },
        position: {
          x: 161,
          y: 25
        }
      }),
      new TextCanvasElement({
        font: {
          size: 16,
          weight: 'bold',
          lineHeight: 17,
          maxWidth: 89,
          numberOfLines: 2
        },
        position: {
          x: 161,
          y: 42
        }
      })
    ])
  ]
};

export default GiftTemplate;
